import { generateClient } from "aws-amplify/api";

// gql
import { gqlQueryGetJobService } from "../../graphql/query/queryGetJobService";

const getData = async ({ user_id, job_id }) => {
  // client
  const gqlclient = generateClient();

  // query
  const res = await gqlclient.graphql({
    query: gqlQueryGetJobService,
    variables: {
      user_id: user_id,
      job_id: job_id
    }
  });
  console.log('services.job.get.job.service@getData', 'res', res);
  const { errors, data } = res;

  // error?
  if (errors) {
    const error = errors[0];
    throw Error(error.message);
  }

  return data.getJobService;
}

async function handler({ user_id, job_id }, { getState, rejectWithValue }) {
  try {
    console.log('services.job.get.job.service@handler', user_id, job_id);

    const res = await getData({
      user_id: user_id,
      job_id: job_id
    });
    console.log('services.job.get.job.service@handler', 'res', res);

    return res;

  } catch (error) {
    console.error('services.job.get.job.service@handler', error);
    return rejectWithValue(error);
  }
}

function pending(state, action) {
  return {
    ...state,
    loading: true,
  };
}

function fulfilled(state, action) {
  return {
    ...state,
    loading: false,
    details: action.payload,
  };
}

function rejected(state, action) {
  return {
    ...state,
    loading: false,
  };
}

export default {
  handler,
  pending,
  fulfilled,
  rejected
}